<template>
   <div style="padding: 0 20px;">
      <p><small><b>{{ getTranslation({ es: 'Categorías', en: 'Categories' }, locale) }}</b></small></p>
    <v-chip
      v-if="categories"
      v-for="(item, index) of categories"
      :key="index"
      class="ma-2"
      :close="selectedCategories.indexOf(item.ID) >= 0"
      :color="selectedCategories.indexOf(item.ID) >= 0 ? item.Color : '#CCCCCC'"
      @click:close="handleClose(item.ID)"
      @click="selectedCategories.push(item.ID)"
      :dark="getIsDark(selectedCategories.indexOf(item.ID) >= 0 ? item.Color : '#CCCCCC')"
      small
    >
    {{ getTranslation(item.Name, locale) }}
    </v-chip>
   </div>
</template>
<script>
import axios from 'axios'
import tinycolor from 'tinycolor2'
import utils from '@/services/utils'
export default {
   props: {
      dtouchWorkspace: {
         type: String,
         required: true,
      },
      content: {
         type: Object,
         required: true,
      },
      locale: {
         type: String,
         default: 'es',
      },
      onChange: {
         type: Function,
         required: true,
      },
   },
   data: () => ({
      categories: null,
      selectedCategories: [],
   }),
   watch: {
      'content.BookingActWorkspaceID' () {
         this.handleGetCategories()
      },
      selectedCategories () {
         this.onChange(this.selectedCategories)
      },
   },
   mounted () {
      this.handleGetCategories()
   },
   methods: {
      getIsDark (v) {
         return tinycolor(v).isLight() ? false : true
      },
      getTranslation (v, locale) {
         return utils.getTranslation(v, locale)
      },
      handleGetCategories () {
         this.categories = null
         const url = `${window.location.protocol}//${process.env.VUE_APP_API_URL_DTOUCH}/v1/public/cm/${this.dtouchWorkspace}/categories/`
         axios.get(url)
            .then((response) => {
               //console.log('response', response)
               if (!response || !response.data) return
               this.categories = response.data.filter(x => !this.content.BookingActWorkspaceID || x.WorkspaceID === this.content.BookingActWorkspaceID).map(item => {
                  item.Color = item.Color ? item.Color : '#000000'
                  return item
               })
            })
            .catch((error) => {
               console.log(error)
            })
            .then(() => {
               this.loading = false
            })
      },
      handleClose (v) {
         this.selectedCategories = this.selectedCategories.filter(x => x !== v)
      },
   },
}
</script>

